import { render, staticRenderFns } from "./StepFooter.vue?vue&type=template&id=1aed6c9c&scoped=true&lang=pug"
import script from "./StepFooter.vue?vue&type=script&lang=ts"
export * from "./StepFooter.vue?vue&type=script&lang=ts"
import style0 from "./StepFooter.vue?vue&type=style&index=0&id=1aed6c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aed6c9c",
  null
  
)

export default component.exports